<template>
  <div class="checkflow">
    <el-form ref="formData" :rules="rules" :model="formData" label-position="left" size="small">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="标题" prop="title" label-width="80px">
            <el-input v-model.trim="formData.title" size="small" maxlength="30" show-word-limit :disabled="flowStatus">
            </el-input>
            <span slot="error" class="item-error">
              <span>请填写标题</span>
            </span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="flowStatus" :gutter="24">
        <el-col :span="12">
          <el-form-item label="项目名称" prop="prjName" label-width="80px">
            <el-input v-model="formData.prjName" size="small" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目编号" prop="prjCode" label-width="80px">
            <el-input v-model="formData.prjCode" size="small" disabled>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="flowStatus" :gutter="24">
        <el-col :span="12">
          <el-form-item label="申请人" prop="operUserName" label-width="80px">
            <el-input v-model="formData.operUserName" size="small" disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提交时间" prop="operTime" label-width="80px">
            <el-input v-model="formData.operTime" size="small" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="设计阶段" label-width="80px">
            <el-input v-model="formData.designStageName" size="small" maxlength="30" show-word-limit
              :disabled="flowStatus"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="存放目录" prop="fileLocationName" label-width="80px">
            <el-input v-model="formData.fileLocationName" readonly :disabled="flowStatus" size="small" @focus="recelocation" />
            <span slot="error" class="item-error">
              <span>请选择存放目录</span>
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="校审专业" prop="acceptSpecialty" label-width="80px">
            <!-- rvt端和cad右键发起不可选择专业 -->
            <template v-if="!clientType||startFlowMode===0">
              <el-select v-if="!flowStatus" v-model="formData.acceptSpecialty" size="small" style="width: 100%"
                clearable filterable :disabled="flowStatus" @change="change_showStartButtons">
                <el-option v-for="item in specList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
              <el-input v-else v-model="formData.acceptSpecialtyName" disabled size="small"></el-input>
            </template>
            <template v-else>
              <el-select v-if="!flowStatus" v-model="formData.acceptSpecialty" size="small" style="width: 100%"
                clearable filterable disabled>
                <el-option v-for="item in specList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
              <el-input v-else v-model="formData.acceptSpecialtyName" disabled size="small"></el-input>
            </template>
            <span slot="error" class="item-error">
              <span>请选择校审专业</span>
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联计划" prop="prjPlanId" label-width="80px">
            <el-select v-if="!flowStatus" v-model="formData.prjPlanId" size="small" style="width: 100%" clearable filterable :disabled="flowStatus" @change="changePrjPlan" @focus="focusPrjPlan">
              <el-option v-for="item in prjPlanData" :key="item.taskId" :label="item.taskName" :value="item.taskId" />
            </el-select>
            <el-input v-else v-model="formData.prjPlanName" disabled size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="内容" prop="content" label-width="80px" style="margin-bottom:8px">
            <el-input v-model.trim="formData.content" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea"
              style="width: 100%" maxlength="200" show-word-limit :disabled="flowStatus"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <template v-if="clientType===2&&startFlowMode===1">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="校审模型" label-width="80px">
              <div class="fileList">
                <div v-for="file in formData.modelList" :key="file.fileId" class="file">
                  <div class="fileText">
                    <!-- 轻量化图标 -->
                    <fileLightFlag v-if="routerParams.flowStatus&&routerParams.status" :row="file" :form-flow="true"
                      @updateLight="updateLight" />
                    <img :src="className(file)" alt="" />
                    <el-link class="fileNameStyle" type="primary" @click="preview(file)">{{ file.fileName }}</el-link>
                  </div>
                  <div v-if="flowStatus" class="options">
                    <i class="el-icon-download" title="下载" style="margin-right: 15px; color: var(--theme-color)"
                      @click="downLoadFile(file)" />
                  </div>
                </div>
              </div>
              <el-button v-if="flowStatus" type="text" @click="refresh">刷新轻量化状态</el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="校审视图" label-width="80px">
              <el-table :data="formData.submitDataViewList" border style="margin:5px 0px">
                <el-table-column label="视图名称" prop="viewName" align="center" show-overflow-tooltip />
                <el-table-column label="类型" prop="type" align="center" show-overflow-tooltip />
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <el-row :gutter="24" style="line-height: 20px">
        <el-col :span="24">
          <el-form-item label="校审文件" label-width="80px">
            <div style="display: flex;align-items: baseline;">
              <el-button size="small" :disabled="flowStatus" @click="uploadFolder">
                <i class="el-icon-plus" style="margin-right:5px"></i>关联文件
              </el-button>

              <span style="margin:0px 20px">
                <el-checkbox v-if="formData.isOverwriteSameNameFile === 1" v-model="formData.isOverwriteSameNameFile"
                  :disabled="flowStatus" :true-label="1" :false-label="0">同名文件覆盖
                </el-checkbox>
                <el-checkbox v-else v-model="formData.isOverwriteSameNameFile" :disabled="flowStatus" :true-label="1"
                  :false-label="0">同名文件重命名
                </el-checkbox>
              </span>

              <el-button v-if="flowStatus&&flowStageName=='绑定'" size="small" style="float:right" @click="bindingAll()">
                全部绑定
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 通用关联文件 -->
    <el-dialog v-dialogDrag append-to-body :visible.sync="fileDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      :close="cancel" title="关联文件" width="600px">
      <el-tree ref="localTree" :load="getlocalTree" :data="localTree" :props="defaultFileProps"
        :check-on-click-node="true" :class="[{ activeShowBar: !showBar }]" class="tree" lazy accordion highlight-current
        show-checkbox @check="currentOrgChangeHandlerLocal">
        <template #default="{ data }">
          <span class="treeitem">
            <img v-if="data.isFolder == 0" :src="className(data)" class="img" alt="" />
            <img v-else :src="icon" class="img" alt="" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="fileDialog = false">取消</el-button>
        <el-button type="primary" size="small" @click="filerecelocationBtn">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 视图框 -->
    <el-dialog v-dialogDrag append-to-body :visible.sync="viewsDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      title="选择视图" width="400px" :close="closeViewsDialog">
      <!-- <el-row :span="24">
        <el-col :span="24">
          <div style="display: flex;align-items: center;">
            <span>图纸集：</span>
            <el-select v-model="" placeholder="">
              <el-option :label="" :value=""></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row> -->
      <el-tree ref="checkViewTree" v-loading="exportViewsListLoading" :data="viewsTreeData" :props="viewsTreeProps"
        highlight-current node-key="id" show-checkbox element-loading-text="视图导出中..." @check="checkViews">
        <template #default="{ data }">
          <span class="treeItem">
            <img v-if="data.viewType == '视图' && data.isLeaf" :src="viewIcon" style="margin-right: 6px" alt="视图" />
            <img v-if="data.viewType == '图纸' && data.isLeaf" :src="viewIcon" style="margin-right: 6px" alt="图纸" />
            <span>{{ data.name }}</span>
          </span>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeViewsDialog">取 消</el-button>
        <el-button type="primary" size="small" :loading="exportViewsListLoading" @click="submitViewsList">确 定
        </el-button>
      </span>
    </el-dialog>

    <!-- 存放目录弹框 -->
    <layPlaceDialog ref="layPlaceDialog" @setFileLocation="setFileLocation" />
  </div>
</template>

<script>
import docService from "@/CommonDP/service/doc-service";
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import layPlaceDialog from "./checkPlaceDialog.vue";
import { tableRowIcon, noLabelFilePreview, is3DModel, is2DModel, common2D3DFileType } from "@/CommonDP/utils/docPublic";
import xtDesign from "@/CommonDP/service/integratedModel-service";
import { downloadFile, flowFileDownLoad } from "@/CommonDP/utils";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";
import fileLightFlag from "@/CommonDP/components/fileLightFlag";
import XtDesignService from "@/CommonDP/service/XtDesign-service";

export default {
  components: { layPlaceDialog, fileLightFlag },
  props: {
    // 流程版本号。与 flowKey 两者不可同时为空
    flowDefinitionId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      viewIcon: require("@/CommonDP/assets/flowIcon/viewIcon.png"),
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      rules: {
        title: [{ required: true, message: "请填写标题", trigger: "blur" }],
        // content: [{ required: true, message: "请填写内容", trigger: "blur" }],
        fileLocationName: [{ required: true, message: "请选择存放目录", trigger: "change" }],
        acceptSpecialty: [{ required: true, message: "请选择校审专业", trigger: "change" }]
      },
      fileDialog: false,
      defaultFileProps: {
        children: "childList",
        label: "folderName",
        isLeaf: "leaf"
      },
      loading: false,
      node_had: {},
      localTree: [],
      resolve_had: {},
      messageObj: {},
      specList: [],
      readonly: false, // 用以替换 flowStatus
      flowStatus: false,
      formData: {
        title: "",
        isOverwriteSameNameFile: 1,
        fileLocationName: "", // 存放目录
        fileLocation: "",
        acceptSpecialty: "",
        acceptSpecialtyName: "",
        modelList: [],
        submitDataViewList: [],
        prjPlanId: '',
        prjPlanName: ''
      },
      flowStageName: "",
      viewsDialog: false,
      viewsTreeData: [],
      viewsTreeProps: {
        label: "name"
      },
      viewsList: [],
      exportViewsListLoading: false,
      prjPlanData: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo,
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    // cad跳转样式 rvt跳转样式
    showBar() {
      if (window.location.href.indexOf("jsName=BimEx") !== -1) {
        return false;
      } else {
        return true;
      }
    },
    isupdate() {
      return this.routerParams.title;
    },

    flowDescribe() {
      return decodeURI(this.routerParams.flowDescribe);
    },
    clientType() {
      return Number(this.routerParams.clientType);
    },
    startFlowMode() {
      return Number(this.routerParams.startFlowMode);
    },
    fileInfoList() {
      return this.routerParams.fileInfoList;
    }
  },
  watch: {
    "formData.acceptSpecialty"(newValue, oldValue) {
      if (newValue) {
        this.getPlanTaskList();
      } else {
        this.formData.prjPlanId = '';
        this.formData.prjPlanName = '';
        this.prjPlanData = [];
      }
    }
  },
  async created() {
    this.formData.approveUserName = this.userInfo.name;
    this.formData.title = this.userInfo.name + "发起" + this.routerParams.name;
    await this.getSpecList();
    this.$nextTick(() => {
      this.$refs.formData.clearValidate();
    });
    if (this.clientType === 2 && this.startFlowMode === 1 && !this.showBar) {
      this.viewsAndFile();
      this.setModelList([this.fileInfoList[0]]);
    }
  },
  methods: {
    refresh() {
      if (this.formData.modelList) {
        const noSuccessfileList = this.formData.modelList.filter((item) => common2D3DFileType(item));
        noSuccessfileList.forEach(async ele => {
          const { data } = await XtDesignService.getFileDetails(ele.fileId);
          this.$set(ele, 'status', data.status);
        });
      }
    },
    updateLight(row, type) {
      const prjId = this.routerParams.enterpriseId || this.enterpriseId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, row.fileId, row.fileVersion)
        .then(res => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
            this.refresh();
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
        });
    },
    setSpecId(specId) {
      this.$set(this.formData, "acceptSpecialty", specId);
    },
    // 接口：用于获取表单数据
    getFormData() {
      const { prjId } = this.routerParams;
      const prjID = prjId || this.prjInfo.prjId;
      return {
        ...this.formData,
        prjId: prjID
      };
    },

    // 接口：设置表单数据
    setFormData(formData) {
      this.formData = formData;
    },
    // 重置表单数据
    resetForm() {
      this.formData.title = this.userInfo.name + "发起" + this.routerParams.name;
      this.formData.isOverwriteSameNameFile = 1;
      this.formData.fileLocationName = [];
      this.formData.fileLocation = [];
      this.formData.modelList = [];
      this.formData.submitDataViewList = [];
      this.formData.prjPlanId = "";
      this.formData.prjPlanName = "";
    },

    // 接口：校验表单数据
    validateFormData() {
      let flag = null;
      this.$refs.formData.validate(valid => {
        if (valid) flag = true;
        else flag = false;
      });
      return flag;
    },

    // 接口：用于获取校审模型
    getModelList() {
      if (this.formData.modelList) {
        this.formData.modelList.forEach(ele => {
          ele.uploadType = 0;
        });
        return this.formData.modelList;
      } else {
        return [];
      }
    },

    // 接口：用于赋值模型
    setModelList(modelList) {
      if (!modelList.length) return;
      modelList[0].fileType = Number(modelList[0].fileType);
      this.formData.modelList = modelList;
    },

    // 如果是revit端的话还得删除表单里的对应的视图
    deleViewObj(obj) {
      this.formData.submitDataViewList = this.formData.submitDataViewList.filter(ele => ele.id !== obj.viewId);
      this.viewsList = this.viewsList.filter(ele => ele.id !== obj.viewId);
    },

    // 初始化视图数据
    async viewsTreeData_init() {
      await CefSharp.BindObjectAsync("cefSharpBrower");
      const data = await cefSharpBrower.revitViewDatas("abc");
      const { viewDatas, viewSheetDatas } = JSON.parse(data) || {};
      this.viewsTreeData = [viewDatas, viewSheetDatas];
    },

    // 打开存放目录弹框
    recelocation() {
      // if (this.formData.acceptSpecialty) {
      this.$refs.layPlaceDialog.dialogShow = true;
      this.$refs.layPlaceDialog.getFrameTree();
      this.$refs.layPlaceDialog.currentDepartment.folderId = this.formData.fileLocation;
      // } else {
      //   this.$message({ message: "请先选择校审专业", type: "warning" });
      // }
    },
    // 设置存放目录
    async setFileLocation(obj) {
      const { folderId } = obj;
      this.formData.fileLocation = folderId;
      const { data } = await workProjectBoardService.getAssociatedFolderLocation(folderId);
      this.formData.fileLocationName = data.map(({ folderName }) => folderName).join("\\");
    },
    closeViewsDialog() {
      this.viewsDialog = false;
    },
    // 选中改变事件
    async checkViews(val, currentChecked) {
      this.viewsList = currentChecked.checkedNodes;
    },
    submitViewsList() {
      this.formData.submitDataViewList = this.viewsList.filter(({ isLeaf }) => isLeaf);
      this.formData.submitDataViewList.forEach(ele => {
        ele.viewId = ele.id;
        ele.viewName = ele.name;
        ele.type = ele.viewType;
      });
      this.exportViewsListLoading = true;
      this.exportView();
      this.exportViewsListLoading = false;
      this.closeViewsDialog();
    },

    // 导出视图
    async exportView() {
      await CefSharp.BindObjectAsync("cefSharpBrower");
      const param = this.viewsList.filter(({ isLeaf }) => isLeaf);
      const list = [];
      await this.queryRevitCheck(param, 0, list);
    },
    async queryRevitCheck(param, index, list) {
      const str = JSON.stringify([param[index]]);
      const data = await cefSharpBrower.revitCheck(str); // revitApproval校审 跟提资有差别
      const arr = JSON.parse(data) || [];
      if (arr.length > 0) {
        arr.forEach(ele => {
          list.push(ele);
        });
        const i = index + 1;
        const l = param.length - 1;
        if (i <= l) {
          this.queryRevitCheck(param, i, list);
        } else {
          this.handleView(list, param);
        }
      }
    },
    // 处理返回的视图文件
    async handleView(data, param) {
      await CefSharp.BindObjectAsync("cefSharpBrower");
      const str = JSON.stringify(param);
      cefSharpBrower.lightweightRvtFile(str);
      const fileList = data || [];
      fileList.forEach(ele => {
        ele.uploadType = 3;
        ele.fileType = Number(ele.fileType);
        // 将文件id给到表格里的fileId
        this.formData.submitDataViewList.forEach(res => {
          if (res.id === ele.viewId) {
            res.fileId = ele.fileId;
          }
        });
      });

      this.$emit("setRvtFileList", fileList || [], this.formData.submitDataViewList);
    },

    // 全部绑定
    bindingAll() {
      this.$emit("bindingAll");
    },
    async getSpecList() {
      const { prjId } = this.routerParams;
      const prjID = prjId || this.prjInfo.prjId;
      const res = await flowService.querySpecList(prjID);
      if (res.data) this.specList = res.data.flowSpecPoList || [];
      if (this.$route.query.major) {
        this.formData.acceptSpecialty = this.$route.query.major || "";
        this.formData.acceptSpecialtyName = this.specList.find(e => e.id === this.$route.query.major)?.name;
      }
    },
    async getPlanTaskList() {
      const specId = this.formData.acceptSpecialty || '';
      const { prjId } = this.routerParams;
      const prjID = prjId || this.prjInfo.prjId;
      const res = await flowService.prjPlanTaskFlowList(this.flowDefinitionId, specId, prjID);
      if (res.data) this.prjPlanData = res.data || [];
    },
    validate() {
      let flag = null;
      this.$refs.formData.validate(valid => {
        if (valid) flag = true;
        else flag = false;
      });
      return flag;
    },
    uploadFolder() {
      const { acceptSpecialty } = this.formData;
      if (acceptSpecialty) {
        this.node_had.childNodes = []; // 把存起来的node的子节点清空，不然会界面会出现重复树！
        this.getlocalTree(this.node_had, this.resolve_had); // 再次执行懒加载的方法
        this.fileDialog = true;
      } else {
        this.$message.warning("请先选择校审专业");
      }
    },
    async getlocalTree(node, resolve) {
      console.log(node);
      const { acceptSpecialty } = this.formData;
      if (node.level === 0) {
        this.node_had = node; // 这里是关键！在data里面定义一个变量，将node.level == 0的node存起来
        this.resolve_had = resolve; // 同上，把node.level == 0的resolve也存起来
        const params = {
          folderId: 0,
          isRead: 1,
          priviAll: "1",
          noRightClickMenu: true,
          prjId: this.prjInfo.prjId || this.routerParams.prjId
        };
        const result = await docService.queryTree(params);
        const list = result.data.filter(({ folderType }) => folderType === 101);// 设计区
        const array = list.map(item => {
          const { childFlag = 0 } = item;
          return {
            isRead: item.isRead,
            priviAll: item.priviAll,
            folderName: item.folderName,
            folderId: item.folderId,
            isFolder: item.isFolder,
            fileType: item.fileType,
            fileVersion: item.fileVersion,
            status: item.status,
            uploadType: 2,
            leaf: childFlag === 0
          };
        });
        return resolve(array);
      } else if (node.level !== undefined) {
        const params = {
          folderId: node.data.folderId,
          isRead: node.data.isRead,
          priviAll: node.data.priviAll,
          noRightClickMenu: true,
          prjId: this.prjInfo.prjId || this.routerParams.prjId
        };
        const res = await docService.queryTree(params);
        const speceList = res.data.filter(({ specId }) => specId === "0" || acceptSpecialty === specId); // 过滤校审专业
        let listArray;
        // rvt端  右键发起  过滤掉rvt文件
        if (this.clientType === 2 && this.startFlowMode === 1) {
          const rvtResList = speceList.filter(({ fileType }) => fileType !== 7 && fileType !== 21); // 过滤rvt文件
          listArray = rvtResList.map(item => {
            const { childFolder = 0 } = item;
            return {
              isRead: item.isRead,
              priviAll: item.priviAll,
              folderName: item.folderName,
              folderId: item.folderId,
              isFolder: item.isFolder,
              fileType: item.fileType,
              fileVersion: item.fileVersion,
              status: item.status,
              leaf: childFolder === 0,
              uploadType: 2
            };
          });
        } else {
          listArray = speceList.map(item => {
            const { childFlag = 0 } = item;
            return {
              isRead: item.isRead,
              priviAll: item.priviAll,
              folderName: item.folderName,
              folderId: item.folderId,
              isFolder: item.isFolder,
              fileType: item.fileType,
              fileVersion: item.fileVersion,
              status: item.status,
              leaf: childFlag === 0,
              uploadType: 2
            };
          });
        }

        return resolve(listArray);
      }
    },
    className(row) {
      return tableRowIcon(row);
    },
    async currentOrgChangeHandlerLocal(val, currentChecked) {
      this.currentFileLocal = currentChecked.checkedNodes;
    },
    async filerecelocationBtn() {
      // 对于通用流程关联文档，确定获取文件夹的子级文件
      if (this.currentFileLocal && this.currentFileLocal.length > 0) {
        const list = [];
        // 对于直接选择文件可以先拿出来
        const array = this.currentFileLocal.filter(({ isFolder }) => isFolder === 0);
        const arrayFolder = this.currentFileLocal.filter(({ isFolder }) => isFolder !== 0);
        const array11 = array.map(item => {
          return {
            fileName: item.folderName,
            fileId: item.folderId,
            fileType: item.fileType,
            isFolder: item.isFolder,
            status: item.status,
            versionIds: item.fileVersion,
            uploadType: 2
          };
        });
        // 选中的文件夹点击确定获取子级数据
        for (const item of arrayFolder) {
          const params = {
            folderId: item.folderId,
            isRead: item.isRead,
            priviAll: item.priviAll,
            noRightClickMenu: true,
            prjId: this.prjInfo.prjId || this.routerParams.prjId
          };
          await docService.queryTree(params).then(({ data }) => {
            let listData = data.map(item => {
              return {
                fileName: item.folderName,
                fileId: item.folderId,
                fileType: item.fileType,
                isFolder: item.isFolder,
                status: item.status,
                versionIds: item.fileVersion,
                uploadType: 2
              };
            });
            // rvt端  右键发起  过滤掉rvt文件
            if (this.clientType === 2 && this.startFlowMode === 1) {
              listData = listData.filter(({ fileType }) => fileType === 7 && fileType === 21); // 过滤rvt文件
            }
            list.push.apply(list, listData);
          });
        }
        // 将获取到的非文件过滤掉
        const listLocal = list.filter(({ isFolder }) => isFolder === 0);
        // 拼接原来选择的文件
        const floderDatanew = array11.concat(listLocal);
        // 过滤一下重复的
        const res = new Map();
        const floderData = floderDatanew.filter(a => !res.has(a.fileName) && res.set(a.fileName, 1));
        this.$emit("tableshow", floderData || []);
      }
      this.fileDialog = false;
    },
    async preview(row) {
      const value = {
        folderId: row.fileId,
        folderName: row.fileName,
        parentId: row.parentId,
        fileVersion: row.versionIds || 1,
        fileType: Number(row.fileType),
        status: row.status
      };
      if (value.status === 2) {
        value.status = value.status.toString();
      }
      const prjId = this.routerParams.prjId || this.prjInfo.prjId;
      // 获取当前项目的名称
      const prjList = await this.getprjList();
      const prj = prjList.find(item => item.prjId === prjId);
      const prjName = prj?.prjName || "";
      const flowInstanceId = this.routerParams.flowInstanceId || '';
      const qmType = this.routerParams.currentNodeName ? this.routerParams.currentNodeName : '';
      const obj = {
        fileId: row.fileId,
        prjId,
        status: row.status,
        versionIds: row.fileVersion || 1,
        fileType: Number(row.fileType),
        source: "ct",
        flowInstanceId,
        qmType
      };
      // web端用value CAD端用obj
      // 判断是否为cad、revit打开的
      if (!this.showBar) {
        obj.noNeedIssue = "";
        await this.isSuccess(obj);
      } else {
        noLabelFilePreview(value, prjId, prjName, "ct", "", "", flowInstanceId, qmType);
      }
    },
    async isSuccess(obj) {
      const { status } = obj;
      if (is3DModel(obj) || is2DModel(obj)) {
        if (Number(status) === 2 || Number(status) === 6) {
          await CefSharp.BindObjectAsync("cefSharpBrower");
          cefSharpBrower.openUrl(JSON.stringify(obj));
        } else {
          this.$message.warning("文件还未轻量化,不支持预览");
        }
      } else {
        await CefSharp.BindObjectAsync("cefSharpBrower");
        cefSharpBrower.openUrl(JSON.stringify(obj));
      }
    },
    async getprjList() {
      const param = {
        enterpriseId: this.routerParams.enterpriseId || this.enterpriseId
      };
      const res = await xtDesign.queryPrj(param);
      const prjList = res.data;
      return prjList;
    },
    cancel() {
      this.localTree = [];
    },
    // 文件下载
    downLoadFile(row) {
      const fileId = row.fileId;
      const versionIds = row.versionIds;
      const url = flowFileDownLoad(this.routerParams.flowInstanceId, fileId, versionIds);
      downloadFile(url);
    },
    // 切换专业 隐藏发起按钮
    change_showStartButtons() {
      this.$emit("change_showStartButtons");
      this.formData.prjPlanId = '';
      this.formData.prjPlanName = '';
    },
    changePrjPlan(val) {
      if (val) {
        this.formData.prjPlanName = this.prjPlanData.find((ele) => ele.taskId === val).taskName;
      } else {
        this.formData.prjPlanName = "";
      }
    },
    focusPrjPlan() {
      if (!this.formData.acceptSpecialty) {
        this.$message.warning("请先选择校审专业");
      }
    },
    async viewsAndFile() {
      await CefSharp.BindObjectAsync("cefSharpBrower");
      const exportGuid = this.$route.query.exportGuid;
      const data = await cefSharpBrower.revitCheck(exportGuid);
      this.$emit('setViewsAndFileData', data);
      // fileList 是树弹窗上点击确定按钮以后返回的数据
      const fileList = JSON.parse(data) || [];
      this.formData.submitDataViewList = fileList || this.fileInfoList.slice(1) || [];
      console.log(fileList, 'fileList');
      fileList.forEach(ele => {
        ele.uploadType = 3;
        ele.fileType = Number(ele.fileType);
      });
      this.$emit("setRvtFileList", fileList || [], this.formData.submitDataViewList);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkflow{
  overflow: hidden;
  .el-form-item{
    margin-bottom:5px;
    /deep/ .el-form-item__label{
      line-height: 32px;
    }
    /deep/ .el-form-item__content{
      line-height: 13px;
    }
  }
  .item-error{
    display: inline-block;
    color: #F56C6C;
    font-size: 12px;
  }
}
.tree {
  overflow: auto;
  height: 500px;
  max-height: 500px;
  width: 100%;
}
.treeitem {
  display: flex;
  align-items: center;
  user-select: none;
}
.activeShowBar {
  max-height: 300px;
  overflow-y: auto;
}
.img {
  margin-right: 6px;
  height: 16px;
  width: 18px;
  user-select: none;
}
.midd-content {
  line-height: 40px;
}
.fileList {
  width: 100%;
  max-height: 300px;
  overflow: auto;
  overflow: overlay !important;
  position:relative;
  .file {
    width: 100%;
    height: 30px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .fileText {
      max-width: calc(100% - 50px);
      display: flex;
      align-items: center;
      img {
        margin-right: 6px;
        height: 20px;
        position: absolute;
        left:25px
      }
      .fileNameStyle{
        cursor: pointer;
        position: absolute;
        left:50px
      }
    }
    .options {
      i {
        font-size: 15px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
  .file:hover {
    background: #f5f7fa;
  }
}
.treeItem {
  display: flex;
  align-items: center;
}
</style>
